import { get } from "lodash";
import PropTypes from "prop-types";
import queryString from "query-string";
import React, { Component } from "react";
import {
  Button,
  ButtonToolbar,
  Col,
  Container,
  Row,
  Image,
  Form
} from "react-bootstrap";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import {
  clearDownloadAgendaMeetingExcelAction,
  clearDownloadAgendaMeetingPptAction,
  clearDownloadAgendaMeetingCabSecPptAction,
  clearDownloadAgendaMeetingPptv2Action,
  downloadAgendaMeetingExcel,
  downloadAgendaMeetingPpt,
  downloadAgendaMeetingPptv2,
  downloadAgendaCabSecPpt,
  clearDownloadAgendaMeetingPptv2WithoutIssueAction
} from "../../actions/dowloadExcelActions";
import {
  agendaHistory,
  downloadMinuteAction,
  getAgendaStakeHolderAction,
  getAgendaSummary,
  getMomDetails,
  sendMeetingRequest,
  sendMinuteAction,
  setUpdateMeetingFilesAction,
  updateMom
} from "../../actions/mom.action";
import DisplayByPermission from "../../component/DisplayByPermission";
import { DownloadAgenda } from "../../component/DownloadAgenda";
import DownloadAgendaBrief from "../../component/DownloadAgendaBrief";
import DownloadAgendaParticipants from "../../component/DownloadAgendaParticipants";
import { LoaderPage } from "../../component/Loader";
import TooltipComponent from "../../component/TooltipComponent";
import { getProjectDetailsforPragti } from "../../services/apiServices";
import request from "../../services/requestService";
import {
  DOCUMENT_FORMATS,
  ERROR_MSG,
  MEETING_OPTION,
  PATHS,
  STATUS,
  DROP_DOWN_VALUES
} from "../../constant";
import {
  dateFormat,
  dateFormatWithTime,
  getLocalstorage,
  isValidArray,
  getAgendaTagsColor,
  getDayOfTheGivenDate,
  getTimeOfTheGivenDate
} from "../../helper";
import { ConfirmationComponent } from "../ConfirmationComponent";
import { AgendaCardInfo } from "../createAgenda/agendaCardInfo";
import PermissionHOC from "../PermissionHOC";
import {
  DisplayAttachments,
  DownloadExcelReport,
  UploadAttachmentsWithTitleComponent
} from "../reusableComponent";
import { SendByComponent1 } from "../sendNotification/Agendaindex";
import { DownloadUploadComponent } from "./downloadUploadReport";
import EditAgenda from "./editAgenda/editAgendaModal";
import GuestList from "./Guests";
import IssueSingleList from "./IssueSingleList";
import { successToastStyle, errorToastStyle } from "../../customToast";
import Meeting from "../../assets/meeting.svg";
import ChairedBy from "../../assets/created-by.svg";
import AgendaSentIcon from "../../assets/agenda-sent-form.svg";
import MeetingModeIcon from "../../assets/meeting-mode-icon.svg";
import Calendar from "../../assets/add-decision-calendar.svg";
import Venue from "../../assets/venue.svg";
import { getMeetingTypesDetails } from "../../actions/projectDetail.action";
import DisabledPPt from "../../assets/disabled-ppt.svg";
import { AgendaDropdown } from "../reusableComponent/customSelectDropDown/AgendaDropdown";
import { DownloadExcelReport1 } from "../reusableComponent/downloadMisComponent/index1";
import PragatiNoDataFound from "../../component/PRAGATINoDataFound";
class PragatiDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      history: [],
      loadingStatus: false,
      isConfirmModalVisible: false,
      agendaMeetingTypeDetails: [],
      isPPTChecked: false,
      selectedValue: "",
      files: [
        // {
        //       "id": 14167,
        //       "title": null,
        //       "mineType": null,
        //       "name": "admin-icon.png",
        //       "s3Url": "https://pmiic-local-files.s3.ap-south-1.amazonaws.com/1719574331453-admin-icon.png",
        //       "s3FileName": "1719574331453-admin-icon.png"
        //   },{
        //     "id": 14167,
        //     "title": null,
        //     "mineType": null,
        //     "name": "admin-icon.png",
        //     "s3Url": "https://pmiic-local-files.s3.ap-south-1.amazonaws.com/1719574331453-admin-icon.png",
        //     "s3FileName": "1719574331453-admin-icon.png"
        // }
      ],
      projectsCount: 0,
      issuesCount: 0,
      displayCount: 0,
      projectData: [],
      issuesData: [],
      agendaDetails: ""
    };
  }

  componentDidMount = async () => {
    const {
      location,
      history,
      getMeetingTypesDetails,
      agendaDetails
    } = this.props;
    const { agendaId: _agendaId } = queryString.parse(location.search);
    const { agendaId } = location.state;
    const response = await request(getProjectDetailsforPragti(agendaId));
    this.setState({
      projectsCount: response.data.data.projectsData.length,
      issuesCount: response.data.data.issuesData.length,
      displayCount: 1,
      projectData: response.data.data.projectsData,
      issuesData: response.data.data.issuesData,
      agendaDetails: response.data
    });
    if (location.state) {
      const { agendaId } = location.state;
      this.getInitialCalls(agendaId);
    } else if (_agendaId) {
      this.getInitialCalls(_agendaId);
    } else {
      history.push(PATHS.AGENDA_LIST);
    }
    getMeetingTypesDetails().then(resp => {
      if (resp) {
        this.setState({ agendaMeetingTypeDetails: resp });
      }
    });
  };

  getInitialCalls = agendaId => {
    const {
      getMomDetails,
      clearDownloadAgendaMeetingPptv2Action,
      clearDownloadAgendaMeetingPptAction,
      clearDownloadAgendaMeetingCabSecPptAction,
      clearDownloadAgendaMeetingExcelAction
    } = this.props;
    //getMomDetails(undefined, { momId: agendaId });
    this.handleHistory(agendaId);
    clearDownloadAgendaMeetingPptv2Action();
    clearDownloadAgendaMeetingPptAction();
    clearDownloadAgendaMeetingCabSecPptAction();
    clearDownloadAgendaMeetingExcelAction();
  };

  changeAgendaDetail = agendaId => {
    const {
      getMomDetails,
      history,
      clearDownloadAgendaMeetingPptv2Action,
      clearDownloadAgendaMeetingPptAction,
      clearDownloadAgendaMeetingCabSecPptAction,
      clearDownloadAgendaMeetingExcelAction
    } = this.props;
    if (agendaId) {
      getMomDetails(undefined, { momId: agendaId });
      this.handleHistory(agendaId);
      clearDownloadAgendaMeetingPptv2Action();
      clearDownloadAgendaMeetingPptAction();
      clearDownloadAgendaMeetingCabSecPptAction();
      clearDownloadAgendaMeetingExcelAction();
    } else history.push(PATHS.AGENDA_LIST);
  };

  handleDropdownSelect = value => {
    this.setState({ selectedValue: value });
    if (this.state.selectedValue.title === "With Issue Status") {
      const { isPPTChecked } = this.state;
      this.setState({
        isPPTChecked: !isPPTChecked
      });
    }
  };

  handleCount = (projectcounts, issuescounts, displaycount) => {
    this.setState({ displayCount: displaycount });
    //console.log(projectcounts,issuescounts);
  };

  handleDownloadLinkClick = () => {
    this.setState({ selectedValue: "" });
  };

  handleAgendaHistory = id => {
    const { getMomDetails, history } = this.props;
    history.push({
      pathname: PATHS.AGENDA_DETAILS,
      search: `?agendaId=${id}`,
      state: {
        agendaId: id
      }
    });
    getMomDetails(undefined, { momId: id });
  };

  handleUpdateStatus = () => {
    const { getMomDetails, location } = this.props;
    const { agendaId: _agendaId } = queryString.parse(location.search);
    if (location.state) {
      const { agendaId } = location.state;
      getMomDetails(undefined, { momId: agendaId });
      this.handleHistory(agendaId);
    } else if (_agendaId) {
      getMomDetails(undefined, { momId: _agendaId });
      this.handleHistory(_agendaId);
    }
  };

  handleHistory = async id => {
    const response = await agendaHistory(undefined, { id: id });
    if (response && response.status) {
      this.setState({
        history: response.data
      });
    }
  };

  handlePrint = () => {
    window.print();
  };

  changeMeetingStatus = async meetingStatus => {
    const { agendaDetails, history, updateMom, getMomDetails } = this.props;
    this.setState({
      loadingStatus: true
    });
    let agendaData = null;
    if (agendaDetails && agendaDetails.data) {
      agendaData = agendaDetails.data;
      agendaData.meetingStatus = meetingStatus;
      let response = null;
      if (meetingStatus === "RESCHEDULE") {
        response = await updateMom(undefined, agendaData);
      } else {
        response = await updateMom(undefined, {
          id: agendaData && agendaData.id,
          meetingStatus: meetingStatus
        });
      }
      if (response) {
        this.setState({
          loadingStatus: false
        });
        const { message, status } = response;
        if (status) {
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          );
          if (meetingStatus === "RESCHEDULE") {
            history.push({
              pathname: PATHS.CREATE_AGENDA,
              state: {
                agendaId: get(response, "data", null)
              }
            });
          }
          if (
            meetingStatus === "CONCLUDED" ||
            meetingStatus === "POSTPONED" ||
            meetingStatus === "CANCELLED"
          ) {
            getMomDetails(undefined, { momId: get(response, "data", null) });
          }
        } else {
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
        }
      } else {
        this.setState({
          loadingStatus: false
        });
        toast.error(
          <p className="toast-text-alignment">
            {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
          </p>,
          errorToastStyle
        );
      }
    }
  };

  downloadMinute = async () => {
    this.setState({ loadingStatus: true });
    const { agendaDetails } = this.props;
    const resp = await downloadMinuteAction(
      undefined,
      get(agendaDetails, "data.id")
    );
    if (resp) {
      this.setState({ loadingStatus: false });
      const { status, data } = resp;
      if (status) {
        window.location.href = get(data, "data");
        toast.success(
          <p className="toast-text-alignment">{ERROR_MSG.DOWNLOAD_SUCCESS}</p>,
          successToastStyle
        );
      } else {
        toast.error(
          <p className="toast-text-alignment">{ERROR_MSG.INVALID_LINK}</p>,
          errorToastStyle
        );
      }
    }
  };

  sendMinute = async () => {
    this.setState({ loadingStatus: true });
    const { agendaDetails } = this.props;
    const resp = await sendMinuteAction(
      undefined,
      get(agendaDetails, "data.id")
    );
    if (resp) {
      this.setState({ loadingStatus: false });
      const { status } = resp;
      if (status) {
        toast.success(ERROR_MSG.SUCCESS);
      } else {
        toast.error(
          <p className="toast-text-alignment">{ERROR_MSG.INVALID_LINK}</p>,
          errorToastStyle
        );
      }
    }
  };

  onToggleSummary = event => {
    event && event.preventDefault();
    this.setState(prevState => ({ openSummary: !prevState.openSummary }));
  };

  onToggleEdit = event => {
    event && event.preventDefault();
    this.setState(prevState => ({ openEditPopup: !prevState.openEditPopup }));
  };

  getAgendaStackeHolder = async () => {
    const {
      agendaDetails: {
        data: { id }
      }
    } = this.props;
    return await getAgendaStakeHolderAction(undefined, id);
  };

  onToggleAttachment = fileId => {
    this.setState(prevState => {
      return {
        toggleAttachementDisplay: !prevState.toggleAttachementDisplay
      };
    });
  };

  onRemoveFile = ({ id }) => {
    try {
      const {
        location,
        getMomDetails,
        agendaDetails: {
          data: { fileDTOList, id: meetingId }
        }
      } = this.props;
      const { agendaId: _agendaId } = queryString.parse(location.search);
      const remaningFiles = fileDTOList
        .filter(value => value.id !== id)
        .map(value => value.id);
      this.setState(
        {
          isremovingfile: true
        },
        async () => {
          const response = await setUpdateMeetingFilesAction(undefined, {
            files: remaningFiles,
            meetingId
          });
          const { data = {} } = response;
          const { status, message } = data;
          //
          if (status) {
            toast.success(
              <p className="toast-text-alignment">
                File is deleted successfully
              </p>,
              successToastStyle
            );
          } else {
            toast.error(
              <p className="toast-text-alignment">{message}</p>,
              errorToastStyle
            );
          }

          this.setState(
            {
              isremovingfile: false
            },
            () => {
              if (location.state && location.state.agendaId) {
                const { agendaId } = location.state;
                getMomDetails(undefined, { momId: agendaId });
                this.handleHistory(agendaId);
              } else if (_agendaId) {
                getMomDetails(undefined, { momId: _agendaId });
                this.handleHistory(_agendaId);
              }
            }
          );
        }
      );
    } catch (error) {
      console.log(`Error while deleting the image ${error.message}`);
    }
  };

  onSuccessUploadOfAttachmets = async fileDto => {
    try {
      const {
        props: {
          agendaDetails: { data = {} }
        }
      } = this;
      const { id: meetingId, fileDTOList = [] } = data || {};
      await setUpdateMeetingFilesAction(undefined, {
        files: [fileDto.id].concat(fileDTOList.map(value => value.id)),
        meetingId
      });
      this.handleUpdateStatus();
      this.onToggleAttachment();
    } catch (error) {
      console.error(error.message);
    }
  };

  toggleMeetingPopUp = () => {
    this.setState(prevState => ({
      showCommentPopUp: !prevState.showCommentPopUp
    }));
  };

  sendMeetingRequestPayload = () => {
    const {
      agendaDetails,
      sendMeetingRequest,
      location,
      getMomDetails
    } = this.props;
    const { id } = agendaDetails.data || {};
    sendMeetingRequest(request, id).then(resp => {
      if (resp.status) {
        const { agendaId: _agendaId } = queryString.parse(location.search);
        if (location.state) {
          const { agendaId } = location.state;
          getMomDetails(undefined, { momId: agendaId });
        } else if (_agendaId) {
          getMomDetails(undefined, { momId: _agendaId });
        }
      }
    });
    this.toggleMeetingPopUp();
  };
  onPPTChecked = () => {
    const { isPPTChecked } = this.state;
    this.setState({
      isPPTChecked: !isPPTChecked
    });
  };

  render() {
    const user = getLocalstorage("user");
    const isUserPMG = getLocalstorage("groupCategory") === "PMG";
    const {
      momDetailsStatus,
      //agendaDetails,
      location,
      permission,
      agendaMeetingPptv2,
      downloadAgendaMeetingPptv2,
      clearDownloadAgendaMeetingPptv2Action,
      agendaMeetingPpt,
      agendaMeetingCabSecPpt,
      downloadAgendaMeetingPpt,
      downloadAgendaCabSecPpt,
      clearDownloadAgendaMeetingPptAction,
      clearDownloadAgendaMeetingCabSecPptAction,
      agendaMeetingExcel,
      downloadAgendaMeetingExcel,
      clearDownloadAgendaMeetingExcelAction,
      getAgendaSummary,
      agendaSummaryData,
      agendaSummaryStatus,
      agendaMeetingPptv2WithoutIssue,
      clearDownloadAgendaMeetingPptv2WithoutIssueAction
    } = this.props;
    const {
      history,
      isremovingfile,
      loadingStatus,
      openSummary,
      openEditPopup,
      showCommentPopUp,
      toggleAttachementDisplay,
      isConfirmModalVisible,
      agendaMeetingTypeDetails,
      isPPTChecked,
      projectsCount,
      issuesCount,
      displayCount,
      agendaDetails
    } = this.state;

    const {
      onRemoveFile,
      onToggleSummary,
      onToggleEdit,
      getAgendaStackeHolder,
      handleUpdateStatus,
      onToggleAttachment,
      onSuccessUploadOfAttachmets,
      onPPTChecked
    } = this;

    let agendaData = null;
    if (agendaDetails && agendaDetails.data) {
      agendaData = agendaDetails.data;
    }
    const mode =
      get(agendaData, "meetingMode") &&
      MEETING_OPTION[get(agendaData, "meetingMode")];

    const isFirefoxBrowser = /Firefox/i.test(navigator.userAgent);
    return (
      <React.Fragment>
        <LoaderPage
          loading={
            momDetailsStatus === STATUS.LOADING ||
            agendaSummaryStatus === STATUS.LOADING ||
            loadingStatus ||
            isremovingfile ||
            displayCount != 1
          }
        />
        {/* {openSummary ? (
          <AgendaCardInfo
            agendaDetails={get(agendaDetails, "data")}
            onClose={onToggleSummary}
          />
        ) : (
          <React.Fragment />
        )} */}
        {/* {openEditPopup ? (
          <EditAgenda
            formData={get(agendaDetails, "data")}
            onClose={onToggleEdit}
            getInitialCalls={this.getInitialCalls}
            agendaMeetingTypeDetails={agendaMeetingTypeDetails}
          />
        ) : (
          <React.Fragment />
        )} */}

        {showCommentPopUp ? (
          <ConfirmationComponent
            show={showCommentPopUp}
            isLoading={false}
            modalClass={"confirmation-modal"}
            saveHandler={this.sendMeetingRequestPayload}
            closeHandler={this.toggleMeetingPopUp}
          />
        ) : null}

        {isConfirmModalVisible ? (
          <ConfirmationComponent
            show={isConfirmModalVisible}
            content={
              agendaSummaryData && agendaSummaryData.data ? (
                <React.Fragment>
                  <table className="table table-striped table-bordered agenda-summary-table">
                    <thead>
                      <tr>
                        <th>Issue with Decision Count</th>
                        <th>Task Completion Date Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{agendaSummaryData.data.decisionCount}</td>
                        <td>{agendaSummaryData.data.taskCompletionCount}</td>
                      </tr>
                    </tbody>
                  </table>
                  <p>Are you sure you want to conclude this agenda?</p>
                </React.Fragment>
              ) : (
                "Are you sure?"
              )
            }
            modalClass={"confirmation-modal projectModalBox"}
            saveHandler={() =>
              this.setState({ isConfirmModalVisible: false }, () =>
                this.changeMeetingStatus("CONCLUDED")
              )
            }
            closeHandler={() => this.setState({ isConfirmModalVisible: false })}
          />
        ) : null}

        <Container className="agenda-detail-container">
          {get(agendaDetails, "data") ? (
            <React.Fragment>
              <Row>
                <Col>
                  <div className="agenda-detail">
                    <React.Fragment>
                      <div className="agenda-details-title">
                        <h3 className="">Agenda Details</h3>
                      </div>
                      <div className="agenda-details agenda-details-id justify-content-start">
                        <div className="agenda-list-title">
                          AGENDA ID{" "}
                          <span className="agenda-id">
                            #{get(agendaData, "id", null)}
                          </span>{" "}
                          |{" "}
                          <span className="agenda-total">
                            {projectsCount} Project(s) & {issuesCount} Issue(s)
                          </span>
                        </div>
                        <div
                          className={`${getAgendaTagsColor(
                            get(agendaData, "meetingStatus", null)
                          )} project-stage-background ml-3`}
                        >
                          <div
                            className={`project-stage`}
                            data-test="project-stage"
                          >
                            <div>{get(agendaData, "meetingStatus", null)}</div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div
                          className={`${
                            isFirefoxBrowser ? "fireFox" : "agenda-contents"
                          }`}
                        >
                          <h3 className="agenda-name">
                            {get(agendaData, "agendaName", null)}
                          </h3>
                          <div className="agenda-wrapper">
                            <div className="agenda-horizontal-view">
                              <div className="agenda-horizontal-view-left">
                                <div className="agenda-detail-info meeting-when">
                                  <span className="agenda-icon-padding">
                                    <Image src={Calendar} alt="Plus Icon" />
                                  </span>
                                  <span>
                                    <b>When</b>
                                    {getDayOfTheGivenDate(
                                      get(agendaData, "meetingDate", null)
                                    ) +
                                      ", " +
                                      dateFormat(
                                        get(agendaData, "meetingDate", null)
                                      )}
                                    {", "}
                                    {getTimeOfTheGivenDate(
                                      get(agendaData, "meetingTimeFrom", null)
                                    )}
                                  </span>
                                </div>
                                <div className="agenda-detail-info">
                                  <span className="agenda-icon-padding">
                                    <Image src={Venue} alt="Plus Icon" />
                                  </span>
                                  <span>
                                    <b>Venue</b>
                                    <p className="Agenda-content">
                                      {get(agendaData, "venueName", null)}
                                    </p>
                                  </span>
                                </div>
                                <div className="agenda-detail-info">
                                  <span className="agenda-icon-padding">
                                    <Image src={Meeting} alt="Plus Icon" />
                                  </span>
                                  <span>
                                    <b>Meeting Type</b>
                                    <p className="Agenda-content">
                                      {get(agendaData, "meetingType", null) ||
                                        "NA"}
                                    </p>
                                  </span>
                                </div>
                              </div>
                              <div className="agenda-horizontal-view-left">
                                <div className="agenda-detail-info pr-4">
                                  <span className="agenda-icon-padding">
                                    <Image src={ChairedBy} />
                                  </span>
                                  <span>
                                    <b>Chaired By</b>
                                    {get(agendaData, "meetingChairedBy", null)}
                                  </span>
                                </div>
                                <div className="agenda-detail-info">
                                  {get(agendaData, "meetingMode") ? (
                                    <>
                                      <span className="agenda-icon-padding">
                                        <Image src={MeetingModeIcon} />
                                      </span>
                                      <span>
                                        <b>Meeting Mode</b>
                                        <p className="Agenda-content">{mode}</p>
                                      </span>
                                    </>
                                  ) : null}
                                </div>
                                <div
                                  className="agenda-detail-info agenda-sent-from"
                                  style={{ visibility: "hidden" }}
                                >
                                  <span className="agenda-icon-padding">
                                    <Image src={AgendaSentIcon} />
                                  </span>
                                  <span>
                                    <b>Agenda Sent From</b>
                                    <p className="Agenda-content">
                                      {get(
                                        agendaData,
                                        "agendaSentFromName",
                                        null
                                      )}
                                    </p>
                                  </span>
                                </div>
                              </div>
                              <div className="agenda-horizontal-view-left">
                                <div>
                                  {get(agendaData, "meetingStatus") !==
                                  "CONCLUDED" ? (
                                    <div className="agenda-sent-from">
                                      {isValidArray(
                                        get(agendaData, "fileDTOList")
                                      ) ? (
                                        <div>
                                          <b className="title attachment-title">
                                            Meeting Documents
                                          </b>
                                          <div style={{ paddingTop: 10 }}>
                                            <DisplayAttachments
                                              filesArr={get(
                                                agendaData,
                                                "fileDTOList"
                                              )}
                                              addAttchementRequired={false}
                                              removeRequired={false}
                                              classes="attachments"
                                              agendadetailcss={true}
                                              pragatidetailcss={true}
                                            />
                                          </div>
                                        </div>
                                      ) : null}
                                    </div>
                                  ) : null}
                                </div>
                                <div>
                                  {get(agendaData, "meetingStatus") ==
                                  "CONCLUDED" ? (
                                    <div className="agenda-sent-from">
                                      {isValidArray(
                                        get(agendaData, "fileDTOList")
                                      ) ? (
                                        <div>
                                          <b className="title attachment-title">
                                            Meeting Documents
                                          </b>
                                          <div style={{ paddingTop: 10 }}>
                                            <DisplayAttachments
                                              filesArr={get(
                                                agendaData,
                                                "fileDTOList"
                                              )}
                                              addAttchementRequired={false}
                                              removeRequired={false}
                                              classes="attachments"
                                              agendadetailcss={true}
                                              pragatidetailcss={true}
                                            />
                                          </div>
                                        </div>
                                      ) : null}
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <div className="agenda-details-btn">
                          <DisplayByPermission
                            display={
                              get(permission, "updateAllAgendaSuperPMG") &&
                              !get(permission, "canViewOnlyProject")
                            }
                          >
                            <Button
                              className={"agenda-btn-summary"}
                              onClick={this.onToggleEdit}
                            >
                              Edit
                            </Button>
                            {get(agendaData, "meetingStatus") === "SCHEDULED" &&
                            get(agendaData, "issueCount") > 0 ? (
                              <div className="last-date-wrapper">
                                {get(agendaData, "lastSentMeetingReminder") ? (
                                  <TooltipComponent
                                    classes="create_project_tolltip"
                                    content={
                                      <>
                                        Last sent on :{" "}
                                        {dateFormatWithTime(
                                          get(
                                            agendaData,
                                            "lastSentMeetingReminder",
                                            null
                                          ),
                                          "LLL"
                                        )}
                                      </>
                                    }
                                  />
                                ) : null}
                                <Button
                                  className={"agenda-btn-summary"}
                                  onClick={this.toggleMeetingPopUp}
                                >
                                  Send Meeting Reminder
                                </Button>
                              </div>
                            ) : null}
                          </DisplayByPermission>
                          <Button
                            className="agenda-btn-summary btn-blue-invert"
                            variant="info"
                            size="sm"
                            onClick={e => {
                              onToggleSummary(e);
                            }}
                          >
                            Agenda Summary
                          </Button>
                          <div />
                          {get(agendaData, "meetingStatus") === "SCHEDULED" ? (
                            <div className="download-options">
                              <DownloadUploadComponent
                                meetingId={get(agendaData, "id")}
                                callApiOnSuccess={handleUpdateStatus}
                                permission={permission}
                              />
                            </div>
                          ) : null}
                        </div> */}
                      </div>
                      {get(agendaData, "meetingStatus") &&
                      get(agendaData, "meetingStatus") !== "DRAFT" &&
                      history.length > 1 ? (
                        <div className="agenda-postponed-data-wrapper">
                          <h3>History ({history.length})</h3>
                          <div className="agenda-postponed-data">
                            <ul>
                              {history.map((list, index) => (
                                <li key={index}>
                                  <div className="agenda-postponed">
                                    <div>
                                      Agenda{" "}
                                      <span
                                        className="history-link"
                                        onClick={() =>
                                          this.handleAgendaHistory(
                                            list.meetingId
                                          )
                                        }
                                      >
                                        #{list.meetingId}
                                      </span>{" "}
                                      | {dateFormat(list.meetingDate)}
                                    </div>
                                    <div className="postponed-on">
                                      {list.status
                                        ? `${list.status.toLowerCase()} on`
                                        : "Postponed on"}{" "}
                                      {dateFormat(list.postponeDate)}
                                    </div>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      ) : null}
                      {get(agendaData, "updatedDate", null) == null ? null : (
                        <>
                          <div
                            className="agenda-created-on"
                            style={{ paddingBottom: 20 }}
                          >
                            Updated on{" "}
                            <span>
                              {getDayOfTheGivenDate(
                                get(agendaData, "updatedDate", null)
                              ) +
                                ", " +
                                dateFormat(
                                  get(agendaData, "updatedDate", null)
                                )}
                              {", "}
                              {getTimeOfTheGivenDate(
                                get(agendaData, "updatedDate", null)
                              )}
                            </span>
                          </div>
                        </>
                      )}
                    </React.Fragment>
                  </div>
                </Col>
              </Row>
              {/* <DisplayByPermission
                display={!get(permission, "canViewOnlyProject")}
              >
                {get(agendaData, "meetingStatus") === "CONCLUDED" ? (
                  <div className="agenda-details-issues agenda-detail-attach-documents">
                    <h3 className="agenda-issues-heading">Meeting Documents</h3>

                    <DisplayAttachments
                      isAgendaAttachment={false}
                      addAttchementRequired={false}
                      onTogglePopUp={onToggleAttachment}
                      filesArr={this.state.files}
                      onRemoveFile={onRemoveFile}
                      agendadetailcss={true}
                      pragatidetailcss={true}
                      removeRequired={false}
                    />
                    {toggleAttachementDisplay ? (
                      <UploadAttachmentsWithTitleComponent
                        agendaData={agendaData}
                        displayModal={toggleAttachementDisplay}
                        onCloseModal={onToggleAttachment}
                        fileFormats={DOCUMENT_FORMATS}
                        onSubmit={onSuccessUploadOfAttachmets}
                      />
                    ) : null} 
                  </div>
                ) : null}
              </DisplayByPermission> */}
              {/* {console.log(get(agendaData, "issuesData", []))} */}
              {isValidArray(get(agendaData, "projectsData", [])) ? (
                <div
                  className="agenda-details-issues"
                  style={{ marginBottom: 40 }}
                >
                  <div
                    className="addissue-heading-wrapper-draft"
                    style={{ marginBottom: 20 }}
                  >
                    <h3
                      className="page-orange-bar"
                      style={{ height: 38, paddingTop: "0.4em" }}
                    >
                      Projects ({projectsCount}) & Issues ({issuesCount})
                    </h3>
                    <div className="page-orange-bar-right">
                      {get(user, "groupCategory") === "PMG" && (
                        <div className="agenda-issues-button-wrapper">
                          <div className="agenda-ppt-v3">
                            {/* <AgendaDropdown
                              customStyle={true}
                              selected={
                                this.state.selectedValue
                                  ? this.state.selectedValue
                                  : { title: "Select" }
                              }
                              options={DROP_DOWN_VALUES}
                              onSelect={value =>
                                this.handleDropdownSelect(value)
                              }
                              isDraft={true}
                            /> */}
                            {!this.state.selectedValue ||
                            this.state.selectedValue.title === "" ? (
                              <>
                                {/* <div className="disabled-ppt1">
                                <img
                                  sizes="10px"
                                  src={DisabledPPt}
                                  variant="outline-info"
                                />
                              </div> */}
                              </>
                            ) : this.state.selectedValue.title ===
                              "Old format" ? (
                              <div
                                className={
                                  get(user, "groupCategory") === "PMG"
                                    ? "agenda-ppt-v3"
                                    : ""
                                }
                              >
                                {/* <DownloadExcelReport
                                  border={true}
                                  isLoading={
                                    agendaMeetingPpt &&
                                    agendaMeetingPpt.isLoading
                                  }
                                  downloadLink={
                                    agendaMeetingPpt &&
                                    agendaMeetingPpt.downloadingSrc
                                  }
                                  onClearDownload={() =>
                                    clearDownloadAgendaMeetingPptAction()
                                  }
                                  onStartDownloading={() =>
                                    downloadAgendaMeetingPpt(
                                      get(agendaData, "id")
                                    )
                                  }
                                  onDownloadLinkClick={
                                    this.handleDownloadLinkClick
                                  }
                                  iconClassName="ppt-icon"
                                  isDraft={true}
                                /> */}
                              </div>
                            ) : this.state.selectedValue.title ===
                              "With issue status" ? (
                              <>
                                {/* <DownloadExcelReport
                                  border={true}
                                  isLoading={
                                    agendaMeetingPptv2 &&
                                    agendaMeetingPptv2.isLoading
                                  }
                                  downloadLink={
                                    agendaMeetingPptv2 &&
                                    agendaMeetingPptv2.downloadingSrc
                                  }
                                  onClearDownload={
                                    clearDownloadAgendaMeetingPptv2Action
                                  }
                                  onStartDownloading={() =>
                                    downloadAgendaMeetingPptv2(
                                      get(agendaData, "id"),
                                      false,
                                      true
                                    )
                                  }
                                  onDownloadLinkClick={
                                    this.handleDownloadLinkClick
                                  }
                                  iconClassName="ppt-icon"
                                  isDraft={true}
                                /> */}
                              </>
                            ) : this.state.selectedValue.title ===
                              "Without issue status" ? (
                              <>
                                <div>
                                  {/* <DownloadExcelReport
                                    border={true}
                                    isLoading={
                                      agendaMeetingPptv2WithoutIssue &&
                                      agendaMeetingPptv2WithoutIssue.isLoading
                                    }
                                    downloadLink={
                                      agendaMeetingPptv2WithoutIssue &&
                                      agendaMeetingPptv2WithoutIssue.downloadingSrc
                                    }
                                    onClearDownload={() =>
                                      clearDownloadAgendaMeetingPptv2WithoutIssueAction()
                                    }
                                    onStartDownloading={() =>
                                      downloadAgendaMeetingPptv2(
                                        get(agendaData, "id"),
                                        false,
                                        false
                                      )
                                    }
                                    onDownloadLinkClick={
                                      this.handleDownloadLinkClick
                                    }
                                    iconClassName="ppt-icon"
                                    isDraft={true}
                                  /> */}
                                </div>
                              </>
                            ) : this.state.selectedValue.title ===
                              "CabSec format" ? (
                              <>
                                {/* <DownloadExcelReport
                                  border={true}
                                  isLoading={
                                    agendaMeetingCabSecPpt &&
                                    agendaMeetingCabSecPpt.isLoading
                                  }
                                  downloadLink={
                                    agendaMeetingCabSecPpt &&
                                    agendaMeetingCabSecPpt.downloadingSrc
                                  }
                                  onClearDownload={
                                    clearDownloadAgendaMeetingCabSecPptAction
                                  }
                                  onStartDownloading={() =>
                                    downloadAgendaCabSecPpt(
                                      get(agendaData, "id")
                                    )
                                  }
                                  onDownloadLinkClick={
                                    this.handleDownloadLinkClick
                                  }
                                  iconClassName="ppt-icon"
                                  isDraft={true}
                                /> */}
                              </>
                            ) : null}
                          </div>
                        </div>
                      )}

                      {get(user, "groupCategory") !== "PMG" && (
                        <div>
                          {/* <DownloadExcelReport
                            isLoading={
                              agendaMeetingPpt && agendaMeetingPpt.isLoading
                            }
                            downloadLink={
                              agendaMeetingPpt &&
                              agendaMeetingPpt.downloadingSrc
                            }
                            onClearDownload={() =>
                              clearDownloadAgendaMeetingPptAction()
                            }
                            onStartDownloading={() =>
                              downloadAgendaMeetingPpt(get(agendaData, "id"))
                            }
                            onDownloadLinkClick={this.handleDownloadLinkClick}
                            iconClassName="ppt-icon"
                          /> */}
                        </div>
                      )}

                      {/* <div className="agenda-meeting-excel">
                        <DownloadExcelReport1
                          isLoading={
                            agendaMeetingExcel && agendaMeetingExcel.isLoading
                          }
                          downloadLink={
                            agendaMeetingExcel &&
                            agendaMeetingExcel.downloadingSrc
                          }
                          onClearDownload={() =>
                            clearDownloadAgendaMeetingExcelAction()
                          }
                          onStartDownloading={() =>
                            downloadAgendaMeetingExcel(get(agendaData, "id"))
                          }
                          isDraft={true}
                        />
                      </div>
                      <DownloadAgendaParticipants
                        id={get(agendaData, "id")}
                        isDraft={true}
                      />
                      <DisplayByPermission
                        display={
                          !get(permission, "canViewOnlyProject") &&
                          (get(user, "groupCategory") === "PMG" ||
                            get(user, "groupCategory") === "STATE_PMG")
                        }
                      >
                        <SendByComponent1
                          meetingId={get(agendaData, "id", null)}
                          containerClass="send_notification agenda-details-compose-button"
                          getStakeHolders={getAgendaStackeHolder}
                          notificationCO={{ momFacetsCO: {} }}
                          customNotificationType="AGENDA"
                          style={"pr-4"}
                        />
                      </DisplayByPermission> */}
                    </div>
                  </div>
                  {/* {console.log(get(agendaData, "issuesData", []))} */}
                  {/* {get(agendaData, "issuesData", []).map((issues, index) => (
                    <React.Fragment key={index}>
                      <IssueSingleList
                        issues={issues}
                        agendaData={agendaData}
                        handleUpdateStatus={this.handleUpdateStatus}
                        changeAgendaDetail={this.changeAgendaDetail}
                        permission={permission}
                        projectData={get(agendaData, "issuesData", []).reduce((acc, current) => {
                          const existing = acc.find(item => item.projectId === current.projectId);
                          if (!existing) {
                            acc.push(current);
                          }
                          return acc;
                        }, [])}
                        onChangeCount={this.handleCount}
                      />
                    </React.Fragment>
                  ))} */}

                  <React.Fragment>
                    <IssueSingleList
                      // issues={issues}
                      agendaData={agendaData}
                      handleUpdateStatus={this.handleUpdateStatus}
                      changeAgendaDetail={this.changeAgendaDetail}
                      permission={permission}
                      projectData={this.state.projectData}
                      issuesData={this.state.issuesData}
                      onChangeCount={this.handleCount}
                    />
                  </React.Fragment>
                </div>
              ) : (
                <>
                  <div
                    className="addissue-heading-wrapper-draft"
                    style={{ marginBottom: 42, marginTop: 30 }}
                  >
                    <h3 className="page-orange-bar">
                      Projects (0) & Issues (0)
                    </h3>
                  </div>
                  <PragatiNoDataFound pragatipage={true} />
                </>
              )}
            </React.Fragment>
          ) : null}
        </Container>
      </React.Fragment>
    );
  }
}
PragatiDetails.propTypes = {
  history: PropTypes.shape({}),
  location: PropTypes.shape({})
};

PragatiDetails.defaultProps = {
  history: {},
  location: {}
};

function mapStateToProps(state) {
  return {
    agendaDetails: state.momReducer.data,
    momDetailsStatus: state.momReducer.momDetailsStatus,
    agendaSummaryData: state.momReducer.agendaSummaryData,
    agendaSummaryStatus: state.momReducer.agendaSummaryStatus,
    isApiLoading: state.addDecisionReducer.isApiLoading,
    agendaMeetingPptv2: state.donwloadExcelReducer.agendaMeetingPptv2,
    agendaMeetingPpt: state.donwloadExcelReducer.agendaMeetingPpt,
    agendaMeetingCabSecPpt: state.donwloadExcelReducer.agendaMeetingCabSecPpt,
    agendaMeetingExcel: state.donwloadExcelReducer.agendaMeetingExcel,
    agendaMeetingPptv2WithoutIssue:
      state.donwloadExcelReducer.agendaMeetingPptv2WithoutIssue
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getMomDetails: getMomDetails,
      updateMom: updateMom,
      sendMeetingRequest: sendMeetingRequest,
      downloadAgendaMeetingPptv2,
      clearDownloadAgendaMeetingPptv2Action,
      downloadAgendaMeetingPpt,
      clearDownloadAgendaMeetingPptAction,
      clearDownloadAgendaMeetingCabSecPptAction,
      getAgendaSummary,
      downloadAgendaMeetingExcel,
      clearDownloadAgendaMeetingExcelAction,
      getMeetingTypesDetails,
      downloadAgendaCabSecPpt,
      clearDownloadAgendaMeetingPptv2WithoutIssueAction
    },
    dispatch
  );
}

export default withRouter(
  PermissionHOC(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(PragatiDetails)
  )
);
